// Designations from Settings > Designation. role_id uses the public designation ID.
export const DESIGNATIONS = [
  { id: 22, publicDesignationId: 11, designation: 'Care Center Agent' },
  { id: 20, publicDesignationId: 10, designation: 'Nurse' },
  { id: 19, publicDesignationId: 8, designation: 'Consultation operator' },
  { id: 18, publicDesignationId: 7, designation: 'Sales operator' },
  { id: 17, publicDesignationId: 6, designation: 'Diagnostics operator' },
  { id: 14, publicDesignationId: 3, designation: 'Doctor' },
  { id: 12, publicDesignationId: 2, designation: 'Medical staff' },
  { id: 2, publicDesignationId: 1, designation: 'Admin' },
  { id: 1, publicDesignationId: 4, designation: 'Nutritionist' },
] as const;

export const designationByRoleId = (roleId?: number | string | null) =>
  DESIGNATIONS.find(({ publicDesignationId }) => publicDesignationId === Number(roleId))
    ?.designation || '';
  